module.exports = __webpack_public_path__ + "static/media/car-6.3977931c.jpg";